// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ah-z","articleImagesWrap":"bh-z","articleImage":"ch-z","singleImage":"dh-z"};